import { Trash2, ArrowUpRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { fmtMoney, ageLabel } from "@/lib/finance";

const channelColor = {
  Wire: "text-cyan-400",
  Crypto: "text-amber-400",
  "Institutional Banking": "text-emerald-400",
};

export const TrancheList = ({ tranches, onDelete }) => {
  return (
    <div className="glass rounded-xl border border-[#232D40] overflow-hidden" data-testid="tranche-list">
      <div className="px-5 py-4 border-b border-[#232D40] flex items-center justify-between">
        <h2 className="font-heading text-lg font-semibold">Active Tranches</h2>
        <span className="text-xs text-slate-500 font-mono-data">{tranches.length} positions · live compounding</span>
      </div>
      {tranches.length === 0 && (
        <div className="p-10 text-center text-slate-500 text-sm">No tranches yet. Log your first capital injection.</div>
      )}
      <div className="divide-y divide-[#232D40]">
        {tranches.map((t) => (
          <div key={t.id} data-testid={`tranche-row-${t.id}`} className="px-5 py-4 flex items-center justify-between gap-4 hover:bg-white/[0.02] transition-colors">
            <div className="flex items-center gap-4 min-w-0">
              <div className="h-9 w-9 rounded-lg bg-amber-500/10 flex items-center justify-center shrink-0">
                <span className="h-2 w-2 rounded-full bg-emerald-400 pulse-dot" />
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-mono-data font-semibold text-slate-100">{fmtMoney(t.principal_amount, 0)}</p>
                  <Badge className={`${channelColor[t.channel] || "text-slate-400"} bg-white/5 border-0 text-[10px] font-mono-data`}>
                    {t.channel}
                  </Badge>
                </div>
                <p className="text-xs text-slate-500 font-mono-data truncate mt-0.5">
                  {new Date(t.injection_datetime).toISOString().slice(0, 16).replace("T", " ")} UTC · {t.tx_reference || "—"}
                </p>
              </div>
            </div>
            <div className="text-right shrink-0">
              <p className="font-mono-data font-bold text-emerald-400 flex items-center gap-1 justify-end">
                <ArrowUpRight className="h-3.5 w-3.5" />{fmtMoney(t.current_balance)}
              </p>
              <p className="text-[11px] text-slate-500 font-mono-data">
                +{fmtMoney(t.accrued_yield, 0)} · {ageLabel(t.age_days)}
              </p>
            </div>
            <button
              data-testid={`delete-tranche-${t.id}`} onClick={() => onDelete(t.id)}
              className="text-slate-600 hover:text-rose-400 transition-colors p-1.5"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
